import React, { Component, Fragment } from 'react'
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js'

import { ai } from './TelemetryService'
import { TelemetryProviderProps } from './types'

import styles from './styles.module.scss'

/**
 * This Component provides telemetry with Azure App Insights
 *
 * NOTE: the package '@microsoft/applicationinsights-react-js' has a HOC withAITracking that requires this to be a Class Component rather than a Functional Component
 */
class TelemetryProvider extends Component<TelemetryProviderProps> {
	state = {
		initialized: false
	}

	componentDidMount() {
		const { history, userName, instrumentationKey } = this.props
		const { initialized } = this.state
		if (!Boolean(initialized) && Boolean(instrumentationKey) && Boolean(history)) {
			ai.initialize(history, instrumentationKey, userName)
			this.setState({ initialized: true })
		}
	}

	render() {
		const { children } = this.props
		return <Fragment>{children}</Fragment>
	}
}

export default withAITracking(
	ai.reactPlugin as unknown as ReactPlugin,
	TelemetryProvider,
	undefined,
	styles.wrapper
)
